import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { getStyles, addModifierClasses, addToArray, getEventAttributes } from '../../../shared/utility';

import Icon from '../Icon/Icon';
import Dots from '../Loading/Dots/Dots';

import localStyles from './Button.scss';
const styles = getStyles(localStyles);

const button = (props) => {
    let buttonClasses = ['button'];
    buttonClasses = addModifierClasses(props.modifiers, 'button', buttonClasses);
    buttonClasses = addToArray(props.classes, buttonClasses);

    const eventAttributes = getEventAttributes(props.events || {});
    const buttonAttributes = !!props.attrs && !!props.attrs.type ? props.attrs : {...props.attrs, type: 'button'};

    const iconStart = !props.icon && !props.iconStart ? null : (
        <Icon
            icon={(props.iconStart || props.icon)}
            attrs={{ ...props.attrs }}
            color={(props.iconStartColor || props.iconColor)}
            classes={styles('button__icon', !props.children ? 'button__icon--only' : null)}
        />
    );

    const iconEnd = !props.iconEnd ? null : (
        <Icon
            icon={(props.iconEnd)}
            attrs={{ ...props.attrs }}
            color={(props.iconEndColor || props.iconColor)}
            classes={styles('button__icon', 'button__icon--end', !props.children ? 'button__icon--only' : null)}
        />
    );

    const innerContent = (
        <Fragment>
            {iconStart}
            {props.children ? props.loading ? <Dots bullets /> : props.children : null}
            {iconEnd}
        </Fragment>
    );

    return props.href ? (
        <NavLink
            to={props.href}
            target={props.target}
            className={styles(buttonClasses)}
        >
            {innerContent}
        </NavLink>
    ) : (
        <button
            disabled={props.disabled || props.loading}
            className={styles(buttonClasses)}
            {...eventAttributes}
            {...buttonAttributes}
        >
            {innerContent}
        </button>
    );
};

button.propTypes = {
    // properties
    classes: PropTypes.string,
    modifiers: PropTypes.arrayOf(PropTypes.string),
    attrs: PropTypes.object,
    events: PropTypes.object,

    icon: PropTypes.string,
    iconColor: PropTypes.string,
    iconStart: PropTypes.string,
    iconStartColor: PropTypes.string,
    iconEnd: PropTypes.string,
    iconEndColor: PropTypes.string,

    children: PropTypes.node,

    href: PropTypes.string,
    target: PropTypes.string,

    loading: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default button;



// WEBPACK FOOTER //
// ./src/components/UI/Button/Button.js